/** Artwork follows the supplied WordCraft design system; symbols remain dynamic. */
export const themeAssets = Object.freeze({
  introduction: '/assets/images/background.PNG',
  board: '/assets/artwork/felt.svg',
  tile: '/assets/artwork/tile-ivory.svg',
  logo: '/assets/artwork/logo-mark.svg',
  rack: '/assets/images/letterbg.PNG',
  panel: '/assets/images/letter.PNG',
  button: '/assets/images/button.png',
  solution: '/assets/images/wordsbg.png',
});

export function applyThemeAssets() {
  for (const [name, path] of Object.entries(themeAssets)) document.documentElement.style.setProperty(`--image-${name}`, `url("${path}")`);
}
